export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10265.beb4b68c.jpg";